<header class="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
  <div class="flex items-center gap-4">
    <p-button (onClick)="toggleSidebar.emit()" [text]="true" [rounded]="true" severity="secondary"
      styleClass="w-10 h-10 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-100">
      <ng-template pTemplate="content">
        <i class="ti ti-menu-2 text-2xl"></i>
      </ng-template>
    </p-button>
    @if (!editorState.isEditorOpen()) {
    <div class="ml-4 text-gray-800">
      <p-breadcrumb [model]="menuItems()" class="text-sm" />
    </div>
    }
  </div>
  <div class="flex items-center gap-4">
    <p-button [text]="true" [rounded]="true" severity="secondary" styleClass="relative w-10 h-10" [disabled]="true">
      <ng-template pTemplate="content">
        <i class="ti ti-bell text-2xl"></i>
        <!-- <span class="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full"></span> -->
      </ng-template>
    </p-button>
    <p-button [text]="true" [rounded]="true" severity="secondary" styleClass="w-10 h-10" [disabled]="true">
      <ng-template pTemplate="content">
        <i class="ti ti-layout-grid text-2xl"></i>
      </ng-template>
    </p-button>
    <p-menu #menu [popup]="true" [model]="items" />
    <p-button [rounded]="true" styleClass="w-10 h-10" (click)="menu.toggle($event)">
      <ng-template pTemplate="content">
        <i class="ti ti-user text-2xl"></i>
      </ng-template>
    </p-button>
  </div>
</header>